"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var asg_1 = require("@alinta-digital/asg");
require("./index.css");
var AmexCVV = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(asg_1.Text, { size: "small", weight: "bold", margin: { top: '8px' } }, "American Express:"),
        react_1.default.createElement("div", { className: "amexCvvImage", "data-testid": "amexCVV" })));
};
exports.default = AmexCVV;
//# sourceMappingURL=AmexCVV.js.map